<template>
  <div :class="authLoading?'account auth-loading':'account'">
    <h1 v-if="!authLoading"></h1>
    <div v-if="!authLoading" class="account-wrap">
      <van-tabs v-model="activeName" :border="false">
        <van-tab title="密码登录" name="1" class="pwd-form">
          <p class="input-cell">
            <!-- <span class="p-txt">手机号</span> -->
            <van-field v-model="loginName" :maxlength="50" placeholder="手机号/邮箱" />
          </p>
          <p class="input-cell">
            <!-- <span class="p-txt">密码</span> -->
            <van-field v-model="passWord" :maxlength="20" type="password" placeholder="请输入密码" />
          </p>
        </van-tab>
        <van-tab title="短信登录" name="2" class="sms-form">
          <p class="input-cell">
            <!-- <span class="p-txt">手机号</span> -->
            <van-field v-model="mobilePhone" :maxlength="50" placeholder="手机号" />
          </p>
          <p class="input-cell">
            <!-- <span class="p-txt">验证码</span> -->
            <van-field v-model="smsVerifyCode" :maxlength="10" placeholder="验证码">
              <div slot="right-icon" class="tel-code">
                  <span v-if="!isSendSms" @click="getSmsCode">获取验证码</span>
                  <span v-if="isSendSms" style="color:#999">{{sendNum}}秒后重新获取</span>
              </div>
            </van-field>
          </p>
        </van-tab>
      </van-tabs>

      <div class="login">
        <van-button type="primary" @click="login">登录</van-button>
      </div>
      <div class="login-links flex-box">
        <a href="javascript://" @click="go">立即注册</a>
        <a style="color:#999;" v-if="activeName == '1'">忘记密码，请到PC端找回</a>
      </div>
      <!-- <p> unionId: {{unionId}}，当前url : {{curUrl}}</p> -->
    </div>
    <van-loading v-if="authLoading" type="spinner" />
  </div>
</template>
<style lang="scss">

/*  绑定账号-自定义页样式  */
.account-wrap {
  .input-cell {
    input {
      font-size:16px;
    }
   }
}

</style>

<style lang="scss" scoped>
  .account{
    background-color: #fff;
    overflow: hidden;
    height: 100%;
    padding-top:50px;
  }
  .auth-loading {
    background-color: #f5f5f5;
    text-align: center;
  }
h1 {
  width:138px;
  height:40px;
  background: url('./img/account.png') no-repeat;
  background-size:100%;
  margin:0 auto;
}

.account-wrap {
  padding: 0 10%;
  margin: 0 auto;
  margin-top: 40px;
  
  .pwd-form,.sms-form {
    padding-top: 20px;
  }
  .input-cell {
    border-bottom:0.5px solid #e5e5e5;
    margin-top: 16px;
    .p-txt {
      font-size:12px;
      color:#999;
    }
    .van-cell {
      padding-left: 5px;
      padding-right: 5px;
    }
    .tel-code {
      color:#22BAA5;
      font-size:14px;
    }
  }
  .sms-form {
    .van-button--default {
      border:none;
      color:#22BAA5;
    }
  }
  .login {
    margin:25px 0 15px 0;
    .van-button {
      width:100%;
      font-size:16px;
    }
  }
  .login-links {
    justify-content: space-between;
  }
}
</style>

<script>

// import { mapMutations } from 'vuex' ;
import { getLink , login , sendSmsLogin , smsLogin , getUserAuthenticationView , getUserInfo} from '@/api/account';
import { isEmailOrPhone , isMobile } from '@/common/utils';
import md5 from 'md5'
import { stat } from 'fs';

import { mapState } from 'vuex' ;

import { Dialog } from 'vant';

export default {
  name: "account-module",
  data() {
    return {
      authLoading:false,
      activeName: "1",
      loginName:"",
      passWord:"",
      mobilePhone:"",
      smsVerifyCode:"",
      isSendSms:false,
      sendNum:60,
      url:this.$route.query.url || '',
      unionId:this.$route.query.unionId || '',
      link:window.location.origin + '/hd-weixin/api/v1/wechat/authorize?returnUrl=' + window.location.href,
      curUrl:window.location.href
    };
  },
  computed:{
    // ...mapState({
    //   getUserInfo: state => state.comp.userInfo || {}
    // })
  },
  components: {},
  methods: {
    go(){
      this.$router.push({path:'/account/register/select', query:{
      //  unionId:this.unionId 
      }});
    },
    // ...mapMutations({
    //   getLogin:'login/APP_LOGIN'
    // }),
    getLoginParams(link){
      const {nonce, randomToken, realm} = link.data;
      const username = this.loginName.trim();
      const password = md5(this.passWord.trim());
      const password2 = md5(password + '5OGP56W65A6D6LSD') + 'x';

      function getAuthorizeCode(input) {
        const ha1 = md5(`${username || ''}:${realm}:${input}`);
        const ha2 = md5('POST:/v1/user/logins/login');
        return md5(`${ha1}:${nonce}:${ha2}`);
      }

      let logparams = {
        loginName: username,
        authorizeCode: getAuthorizeCode(password),
        twoAuthorizeCode: getAuthorizeCode(password2)
        //unionId:this.unionId
      };
      return logparams;
    },
    login(){
      if(this.activeName == '1'){ //密码登录
          this.loginPwd();
      }else{ //短信登录
          this.loginSms();
      }
    },
    //登录后 检查认证 状态
    checkAuthStatus(){
      getUserInfo().then(res=>{
          let data = res.data;
          
          if(data.certificatesUserStatus==0){
            if(data.certificatesAuthenticationStatus!=2){//未实名认证
              this.$router.push({path:'/account/certification', query:{
                status:data.certificatesAuthenticationStatus || ''
              }});
              return;
            }
          }
          
          //去职位列表
          let p = (this.url || '/positions');
          this.$router.replace({path: p});

      }).catch(err => {
        this.authLoading = false;
      });
    },
    loginPwd(){
      if(!this.loginName.trim()){
        this.$toast('请填写手机号或邮箱');
        return;
      };
      if(!isEmailOrPhone(this.loginName.trim())){
        this.$toast('手机号或邮箱格式不正确');
        return;
      };
      if(!this.passWord.trim()){
        this.$toast('请输入密码');
        return;
      };
      // unionId
      getLink().then(link => {
        let params = this.getLoginParams(link);
        login(params).then(res=>{
          
          this.checkAuthStatus();
          
        }).catch( err => {
          
        })
      });

    },
    checkMobile(){
      if(!this.mobilePhone.trim()){
        this.$toast('请填写手机号或邮箱');
        return;
      };
      if(!isMobile(this.mobilePhone.trim())){
        this.$toast('手机号格式不正确');
        return;
      };
      return true;
    },
    loginSms(){
      if(!this.checkMobile()) return;
      if(!this.smsVerifyCode.trim()){
        this.$toast('请输入验证码');
        return;
      };
      
      smsLogin({
        mobilePhone: this.mobilePhone,
        smsVerifyCode: this.smsVerifyCode,
        unionId:this.unionId
      }).then( res => {
        
        this.checkAuthStatus();
      }).catch( err => {})
      
    },
    countDown(){
      this.isSendSms = true;
      let timer = null;
      let fn = ()=>{
        clearTimeout(timer);
        if(this.sendNum <= 1){
          timer = null;
          this.isSendSms = false;
          this.sendNum = 0;
          return;
        };
        this.sendNum -- ;
    
        timer = setTimeout(fn ,1000);
      }
      timer = setTimeout(fn ,1000);
    },
    getSmsCode(){
      
      if(!this.checkMobile()) return;
      getLink().then(link => {
        sendSmsLogin({
          mobilePhone: this.mobilePhone
        }).then( res => {
          this.countDown();
        }).catch( err => {});
      });
    }
  },
  created() {
    let isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 };
    const query = this.$route.query;

    if(isWeiXin()){
      this.authLoading = true;
      if(!('authorCode' in query)){
        window.location.href= window.location.origin + '/hd-weixin/api/v1/wechat/authorize?returnUrl=' + window.location.href;
      }else{
        if('isBound' in query){ //是否绑定
          if(query.isBound == 'true'){
              if(query.errorCode){
                if(query.errorCode == 'USER_LOGIN_LIMITED_SOHO'){
                  Dialog.alert({
                    message: '很抱歉您目前没有组织，请加入猎企后再登录'
                  }).then(() => {
                    // on close
                  });
                  
                };
                if(query.errorCode == 'USER_LOGIN_LIMITED_COMPANY",'){
                  Dialog.alert({
                    message: '您的猎企目前没有通过认证审核，您暂时无法登录，更多问题请联系客服'
                  }).then(() => {
                    // on close
                  });
                  
                };
                if(query.errorCode == 'CAN_NOT_JOIN_COMPANY'){
                  Dialog.alert({
                    message: '您当前不属于一家公司，不能登录'
                  }).then(() => {
                    // on close
                  });
                  
                };
                this.authLoading = false;
                return;
            };

            // 授权成功 并且有绑定 直接后面的流程
            this.checkAuthStatus();

          }else{
            // 未绑定，用户自己登录绑定
            this.authLoading = false;
          }
        }
      } 
    }; 
    
   
    // console.log(this.url);
  },
  mounted(){
    // console.log('account created----设置账号频道');
    // this.$store.commit('comp/WX_SHARE',{
    //   title:'账号频道'
    // });
    // console.log('account mouted');
  }
};
</script>
